export var WebGLKind;
(function (WebGLKind) {
    WebGLKind["webgl1"] = "webgl";
    WebGLKind["webgl2"] = "webgl2";
    WebGLKind["experimental"] = "experimental-webgl";
    WebGLKind["no"] = "no";
    WebGLKind["error"] = "error";
})(WebGLKind || (WebGLKind = {}));
function testWebGLKind(kind) {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext(kind);
    if (gl)
        return true;
    return false;
}
let cached = null;
function realDetect() {
    try {
        const tests = [WebGLKind.webgl2, WebGLKind.webgl1, WebGLKind.experimental];
        for (const kind of tests) {
            if (testWebGLKind(kind)) {
                console.log(`WebGL kind '${kind}' is supported`);
                return kind;
            }
        }
    }
    catch (error) {
        console.log(`Error while detecting WebGL support: ${error}`);
        return WebGLKind.error;
    }
    console.log('No WebGL support :(');
    return WebGLKind.no;
}
export function detectWebGLKind() {
    if (cached == null)
        cached = realDetect();
    return cached;
}
